import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ShowToast, ToggleDarkMode } from '../actions/layout.action';
import { ToastService } from '../../ui/toast/toast.service';

@Injectable()
export class LayoutEffects {
  toggleDarkMode$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ToggleDarkMode),
        tap((action) => {
          const body = this.document.querySelector('body');
          const value = action.enabled ? 'dark' : 'light';
          body?.setAttribute('data-theme', value);
        })
      );
    },
    { dispatch: false }
  );

  showToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ShowToast),
        tap(({ message }) =>
          this.toastService.show(message.detail, message.severity)
        )
      ),
    { dispatch: false }
  );

  constructor(
    private toastService: ToastService,
    private actions$: Actions,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}
}
